import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FieldIconFragmentGql } from './FieldIconFragmentGql';

export const LensFieldsByIdQueryGql: DocumentNode = gql`
query LensFieldsByIdQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensFieldSortOrder!) {
  lenses(filter: { vizportalUrlId: $vizportalUrlId }) {
    id
    name
    vizportalUrlId
    fieldsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        id
        name
        description
        datasourceField {
          id
          name
          description
          ...FieldIconFragment
        }
      }
    }
  }
}
${FieldIconFragmentGql}
`;
